import { GoogleMapsContext } from '@vis.gl/react-google-maps'
import { useContext, useEffect, useMemo, useRef } from 'react'

export type CircleProps = google.maps.CircleOptions

export const Circle = (props: CircleProps) => {
  const map = useContext(GoogleMapsContext)?.map
  const circleRef = useRef<google.maps.Circle | null>(null)

  // update options only when something changes
  const options = useMemo(() => ({ ...props }), [props])

  useEffect(() => {
    if (!map) return

    // only instantiate when map is ready
    if (!circleRef.current) {
      circleRef.current = new google.maps.Circle({ map, ...options })
    } else {
      circleRef.current.setMap(map)
      circleRef.current.setOptions(options)
    }

    return () => {
      circleRef.current?.setMap(null)
    }
  }, [map, options])

  return null
}

Circle.displayName = 'Circle'
